//@flow
import amplitude from 'amplitude-js'

/**
 * If not in a production environment, use a mock of the amplitude API.
 * Else use the real thing.
 */
const Amplitude =
  process.env.NODE_ENV === 'production'
    ? amplitude
    : {
      init: (...args: any) => {
        /*no-op*/
      },
      amplitude: (...args: any) => {
        /*no-op*/
        return {}
      },
      logEvent: (...args: any) => {
        /*no-op*/
      },
      setUserId: (...args: any) => {
        /*no-op*/
      },
    }

export default Amplitude



// WEBPACK FOOTER //
// ./src/analytics/amplitude.js